//node modules
import React, {lazy} from "react";

//errorPages-pages
//icons
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import PestControlOutlinedIcon from "@mui/icons-material/PestControlOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import ListOutlined from "@mui/icons-material/ListOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";

//pages
import LoginUser from "../pages/account/LoginUser";

//lazy-pages
const Landing = lazy(() => import("../pages/landing/landing"));
const Dashboard = lazy(() => import("../pages/dashboard"));
const Campaigns = lazy(() => import("../pages/campaigns"));
const ViewCampaign = lazy(
  () => import("../pages/campaigns/pages/viewCampaign"),
);
const Orders = lazy(() => import("../pages/orders"));
const Settlement = lazy(() => import("../pages/settlement"));
const ViewSettlement = lazy(
  () => import("../pages/settlement/pages/viewSettlement"),
);
const Managers = lazy(() => import("../pages/managers"));
const ViewManager = lazy(() => import("../pages/managers/pages/viewManager"));
const MailCreator = lazy(
  () => import("../pages/outbox/mails/pages/templateCreator"),
);
const PrizesList = lazy(() => import("../pages/prizes"));
const MailsOverview = lazy(() => import("../pages/outbox/mails"));
const ViewPlan = lazy(() => import("../pages/outbox/mails/pages/viewPlan"));
const ViewPrizes = lazy(() => import("../pages/prizes/pages/viewPrizes"));
const SystemErrors = lazy(() => import("../pages/system/error/systemError"));
const SmsOutbox = lazy(() => import("../pages/outbox/sms"));
const Statistics = lazy(() => import("../pages/statistics"));
const DistributerOrdersOverview = lazy(
  () => import("../pages/distrubuter/orders/DistributerOrdersOverview"),
);
const Access = lazy(() => import("../pages/admin/settings/Access"));
const AdminActions = lazy(() => import("../pages/admin/settings/Actions"));
const Suppliers = lazy(() => import("../pages/supplier/index"));
const ViewSupplier = lazy(() => import("../pages/supplier/pages/viewSupplier"));
const ViewSupplierCampaign = lazy(
  () => import("../pages/supplier/pages/viewSupplierCampaign"),
);

//errorPages pages
const Error404 = lazy(() => import("../pages/errorPages/notfound"));

export enum PagePermission {
  ADMIN,
  MODERATOR,
  DISTRIBUTER,
  SUPPLIER,
}

//lazy-agreementPages

const campaignPages = [
  {
    link: "/campaigns",
    element: Campaigns,
    displayInSideNav: true,
    page: "Kampanjer",
    icon: <CalendarTodayOutlinedIcon/>,
    needAuth: PagePermission.MODERATOR,
  },
  {
    link: "/campaigns/:campaign",
    element: ViewCampaign,
    displayInSideNav: false,
    page: "Kampanje Info",
    icon: "",
    needAuth: PagePermission.MODERATOR,
  },
];

const managerPages = [
  {
    link: "/managers",
    element: Managers,
    displayInSideNav: true,
    page: "Managere",
    icon: <WorkOutlineOutlinedIcon/>,
    needAuth: PagePermission.MODERATOR,
  },
  {
    link: "managers/:managerID",
    element: ViewManager,
    displayInSideNav: false,
    page: "Manager Info",
    icon: "",
    needAuth: PagePermission.MODERATOR,
  },
];

const orderPages = [
  {
    link: "/orders",
    element: Orders,
    displayInSideNav: true,
    page: "Ordre historikk",
    icon: <ListAltOutlinedIcon/>,
    needAuth: PagePermission.MODERATOR,
  },
];

const administrationPages = [
  {
    link: "/settlement",
    element: Settlement,
    displayInSideNav: true,
    page: "Oppgjør",
    icon: <PaymentsOutlinedIcon/>,
    needAuth: PagePermission.ADMIN,
  },
  {
    link: "/settlement/:campaign",
    element: ViewSettlement,
    displayInSideNav: false,
    page: "Oppgjør informasjon",
    icon: "",
    needAuth: PagePermission.ADMIN,
  },
  {
    link: "/prizes",
    element: PrizesList,
    displayInSideNav: true,
    page: "Gevinster",
    icon: <EmojiEventsOutlinedIcon/>,
    needAuth: PagePermission.MODERATOR,
  },
  {
    link: "prizes/:prizeID",
    element: ViewPrizes,
    displayInSideNav: false,
    page: "Gevinst infomrasjon",
    icon: "",
    needAuth: PagePermission.MODERATOR,
  },
];

const systemPages = [
  {
    link: "system/errors",
    element: SystemErrors,
    displayInSideNav: true,
    page: "System feilmeldinger",
    icon: <PestControlOutlinedIcon/>,
    needAuth: PagePermission.MODERATOR,
  },
  {
    title: "Admin",
    displayInSideNav: true,
    icon: <AdminPanelSettingsOutlinedIcon/>,
    needAuth: PagePermission.ADMIN,
    subPages: [
      {
        link: "/admin/permissions",
        element: Access,
        displayInSideNav: true,
        page: "Tilganger",
        needAuth: PagePermission.ADMIN,
      },
      {
        link: "/admin/actions",
        element: AdminActions,
        displayInSideNav: true,
        page: "Opperasjoner",
        needAuth: PagePermission.ADMIN,
      },
    ],
  },
];

const mailPages = [
  {
    title: "Utsendelser",
    displayInSideNav: true,
    icon: <MarkEmailReadOutlinedIcon/>,
    needAuth: PagePermission.ADMIN,
    subPages: [
      {
        link: "/mails",
        element: MailsOverview,
        displayInSideNav: true,
        page: "Epost",
        needAuth: PagePermission.ADMIN,
      },
      {
        link: "/template-creator/:id",
        element: MailCreator,
        displayInSideNav: false,
        page: "Mal lager",
        icon: "",
        needAuth: PagePermission.ADMIN,
      },
      {
        link: "/mail-plan/:id",
        element: ViewPlan,
        displayInSideNav: false,
        icon: "",
        needAuth: PagePermission.ADMIN,
      },

      {
        link: "/sms",
        element: SmsOutbox,
        displayInSideNav: true,
        page: "Sms",
        needAuth: PagePermission.ADMIN,
      },
    ],
  },
];

const dashboardPages = [
  {
    link: "/",
    element: Landing,
    displayInSideNav: false,
    page: "Hjem",
    icon: <HomeOutlinedIcon/>,
    needAuth: PagePermission.SUPPLIER,
  },
  {
    link: "/dashboard",
    element: Dashboard,
    displayInSideNav: true,
    page: "Oversikt",
    icon: <GridViewOutlinedIcon/>,
    needAuth: PagePermission.MODERATOR,
  },
];

const statisticsPages = [
  {
    link: "/statistics",
    element: Statistics,
    displayInSideNav: true,
    page: "Statistikk",
    icon: <InsertChartOutlinedIcon/>,
    needAuth: PagePermission.MODERATOR,
  },
];

const distributerPages = [
  {
    title: "Distributør",
    displayInSideNav: true,
    icon: <LocalShippingOutlinedIcon/>,
    needAuth: PagePermission.DISTRIBUTER,
    subPages: [
      {
        link: "/distributer/orders",
        element: DistributerOrdersOverview,
        displayInSideNav: true,
        page: "Ordre liste",
        icon: <ListOutlined/>,
        needAuth: PagePermission.DISTRIBUTER,
      },
    ],
  },
];

const supplierPages = [
  {
    link: "/supplier", //supplierID
    element: Suppliers,
    displayInSideNav: true,
    page: "Leverandør",
    icon: <LocalShippingOutlinedIcon/>,
    needAuth: PagePermission.SUPPLIER,
  },
  {
    link: "/supplier/:supplierID", //supplierID
    element: ViewSupplier,
    displayInSideNav: false,
    page: "Leverandør",
    icon: <LocalShippingOutlinedIcon/>,
    needAuth: PagePermission.SUPPLIER,
  },
  {
    link: "/supplier/:supplierID/campaigns/:managerID/:campaignID", //supplierID
    element: ViewSupplierCampaign,
    displayInSideNav: false,
    page: "Leverandør",
    icon: "",
    needAuth: PagePermission.SUPPLIER,
  },
];
/*
const supplierPages = [
  {
    title: "Leverandør",
    displayInSideNav: true,
    icon: <LocalShippingOutlinedIcon />,
    needAuth: PagePermission.SUPPLIER,
    subPages: [
      {
        link: "/supplier",
        element: Suppliers,
        displayInSideNav: true,
        page: "Oversikt",
        icon: "",
        needAuth: PagePermission.SUPPLIER,
      },
      {
        link: "/supplier/:supplierID", //supplierID
        element: ViewSupplier,
        displayInSideNav: true,
        page: "Leverandør",
        icon: "",
        needAuth: PagePermission.SUPPLIER,
      },
      {
        link: "/supplier/:supplierID/campaigns/:managerID/:campaignID", //supplierID
        element: ViewSupplierCampaign,
        displayInSideNav: false,
        page: "Leverandør",
        icon: "",
        needAuth: PagePermission.SUPPLIER,
      },
    ],
  },
];
*/
const authPages = [
  ...dashboardPages,
  ...statisticsPages,
  ...managerPages,
  ...campaignPages,
  ...orderPages,
  ...distributerPages,
  ...administrationPages,
  ...mailPages,
  ...systemPages,
  ...supplierPages,
];

const noneAuthPages = [
  {
    link: "/login",
    element: LoginUser,
    displayInSideNav: false,
    page: "Login",
    icon: "",
    needAuth: false,
  },
];

const errorPages = [
  {
    link: "/not_found",
    element: Error404,
    displayInSideNav: false,
    page: "Side ikke funnet",
    icon: "",
    needAuth: false,
  },
  {
    link: "*",
    element: Error404,
    displayInSideNav: false,
    page: "Side ikke funnet",
    icon: "",
    needAuth: false,
  },
];

export const pageTree = [
  //errorPages pages
  ...errorPages,

  //pages
  ...authPages,
  ...noneAuthPages,
];
